export default {
    name: 'radio-button-group',
    components: {},
    props: {
        /**
         * Radio button values object array
         */
        radiobuttonValues: {
            type: Array,
        },
        /**
         * Name of the radio button group
         */
        name: {
            type: String,
        },
        /**
         * Value of the radio button group
         */
        value: {
            type: String,
        },
        /**
         * Alignment of the radio button group
         */
        arrangeHorizontal: [Boolean, Function]
    },
    data(){
        return {
            radioButtonchecked: ''
        };
    },
    computed: {},
    mounted(){
        this.$emit('radioButtonMounted', {});
        if(this.value){
            this.setSelectedByValue(this.value);
        }
    },
    methods: {
        /**
         * To set radio button  value
         * @param {Object} optionSelected option selected
         */
        setSelectedByValue(optionSelected){
            this.radioButtonchecked = optionSelected;
        },
        // To get  radio button   value
        getSelectedRadio(){
            return this.radioButtonchecked;
        },
        // Radio button on selected will emit selected option object that contains label and value
        radioButtonOptionChange(item){
            if(this.radioButtonchecked !== item.value){
                this.radioButtonchecked = item.value;
                this.$emit('selected-option', item);
                this.$emit('input', item.value);
            }
        },
        // function to prepopulate radio button.
        radioButtonPrePopulate(value){
            this.radioButtonchecked = value;
        },
        // function to reset radio button group.
        resetRadioGroup(){
            this.radioButtonchecked = '';
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-radio-button-group/vx-radio-button-group.js